<template>
  <div class="shop-log-page">
    <div class="shop-log-total-spent">
      <p style="color: white; font-size: 15px">Your Total Spent as of today {{ dateToday }} is <span style="font-size: 20px; color: red">{{ totalSpent }}</span></p>
    </div>
    <div class="shop-log-table">
      <q-table
        bordered
        title="Shop Logs"
        :rows="tableData.data"
        :columns="columns"
        row-key="ID"
        separator="cell"
        dark
        :loading="loading"
        :hide-pagination="true"
        :rows-per-page-options="[15]"
        wrap-cells
      />
      <div class="q-pa-lg flex flex-center pagination">
        <q-pagination
          v-model="pagination.current"
          :max="pagination.last"
          direction-links
          outline
          color="orange"
          active-design="unelevated"
          active-color="brown"
          active-text-color="orange"
          @update:model-value="getShopLogs()"
          :max-pages="3"
        />
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  name: 'ShopLogs',
  computed: {
    dateToday () {
      return moment(new Date()).format('DD MMMM YYYY hh:mm:ss A')
    }
  },
  data () {
    return {
      separator: { label: 'Cell', value: 'cell' },
      columns : [
        {
          name: 'ID',
          align: 'center',
          label: 'ID',
          field: 'ID'
        },
        {
          name: 'Action',
          align: 'center',
          label: 'Action',
          field: 'action'
        },
        {
          name: 'Price',
          align: 'center',
          label: 'Price',
          field: 'price'
        },
        {
          name: 'Remarks',
          align: 'center',
          label: 'Remarks',
          field: 'remarks'
        },
        {
          name: 'Date',
          align: 'center',
          label: 'Date',
          field: 'CreatedAt'
        }
      ],
      tableData: [],
      totalSpent: 0,
      loading: true,
      pagination: {
        current: 1,
        last: 1
      },
    }
  },
  mounted () {
    this.$q.loading.show()
    this.loading = true
    this.getShopLogs()

    this.loading = false
    this.$q.loading.hide()
  },
  methods: {
    ...mapActions({
      shopLogs: 'user/shopLogs'
    }),
    async getShopLogs () {
      const parameter = {
        params: {
          page: this.pagination.current
        }
      }
      await this.shopLogs(parameter)
        .then(response => {
          const { shop_logs, total_spent } = response.data.data

          this.tableData = shop_logs

          this.totalSpent = total_spent
          
          this.pagination.current = shop_logs.current_page
          this.pagination.last = shop_logs.last_page
        })
        .catch(error => {
          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative',
          })
        })
    }
  }
}
</script>
<style lang="scss">
.shop-log-page {
  background-color: $background;
  padding: 24px;
  border-radius: 5px;
}
</style>